/**
 * Gestion de la landing page
 * Guest account creation: handled by components/guest-play.js (auto-initializes)
 */
import './components/guest-play.js';

// Animation on scroll
function initScrollAnimations() {
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
            }
        });
    }, observerOptions);

    document.querySelectorAll('.fade-in').forEach(el => {
        observer.observe(el);
    });
}

// Celebrity cards hover effects
function initCelebrityCards() {
    document.querySelectorAll('.celebrity-card').forEach(card => {
        card.addEventListener('mouseenter', function() {
            this.style.transform = 'translateY(-5px) scale(1.02)';
        });
        
        card.addEventListener('mouseleave', function() {
            this.style.transform = 'translateY(0) scale(1)';
        });
    });
}

// Kanji glow effects
function initKanjiEffects() {
    document.querySelectorAll('.kanji').forEach(kanji => {
        kanji.addEventListener('mouseenter', function() {
            this.style.textShadow = '0 0 30px rgba(224, 140, 41, 1)';
        });
        
        kanji.addEventListener('mouseleave', function() {
            this.style.textShadow = '0 0 20px rgba(224, 140, 41, 0.7)';
        });
    });
}

// Initialisation au chargement de la page
function initLandingPage() {
    initScrollAnimations();
    initCelebrityCards();
    initKanjiEffects();
    // Note: Guest play buttons are handled by guest-play.js (auto-initialized)
}

// Auto-init si pas utilisé comme module
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLandingPage);
} else {
    initLandingPage();
}